import { useEffect, useMemo, useState } from 'react';
import { doPostQCXRequest } from '../../../utils/api/domain/domain-api-utils';
import QCXAtributosTratamentoTributarioDuimpV3 from '../../../shared-components/atributos-tratamento-tributario-duimp/QCXAtributosTratamentoTributarioDuimpV3';
import QCXAuxiliarSelectFundamentosOpcionais from './QCXAuxiliarSelectFundamentosOpcionais';

export default function RepassarTratamentosTributariosOpcionaisTab({
  values = {},
  disabled = false,
  faturaId,
  onMercadoriasPermitidasChange,
  isActive = true,
}) {
  const [listTratamentosAtributos, setListTratamentosAtributos] = useState([]);

  const mercadoriaIdsSelecionadas = useMemo(
    () =>
      (Array.isArray(values?.meta?.selected) ? values.meta.selected : [])
        .map((mercadoria) => Number(mercadoria?.id))
        .filter((mercadoriaId) => Number.isInteger(mercadoriaId)),
    [values?.meta?.selected]
  );
  const codigosFundamentosLegaisSelecionados = useMemo(
    () =>
      (Array.isArray(values?.ignorableFields?.tratamentosTtce?.metadados?.opcionais)
        ? values.ignorableFields.tratamentosTtce.metadados.opcionais
        : []
      )
        .map((tratamento) => tratamento?.fundamento?.id)
        .filter((codigoFundamentoLegal) => codigoFundamentoLegal !== null && codigoFundamentoLegal !== undefined)
        .map(String),
    [values?.ignorableFields?.tratamentosTtce?.metadados?.opcionais]
  );

  const mercadoriaIdsKey = mercadoriaIdsSelecionadas.join(',');
  const codigosFundamentosLegaisKey = codigosFundamentosLegaisSelecionados.join(',');

  useEffect(() => {
    if (!isActive) {
      setListTratamentosAtributos([]);
      return undefined;
    }

    if (!mercadoriaIdsSelecionadas.length || !codigosFundamentosLegaisSelecionados.length) {
      setListTratamentosAtributos([]);
      return undefined;
    }

    let isMounted = true;

    const buscarAtributosTratamentos = async () => {
      try {
        const response = await doPostQCXRequest(['diduimp', 'auxiliar', 'buscar-atributos-tratamentos-opcionais'], {
          mercadoriaIds: mercadoriaIdsKey.split(',').map(Number),
          codigosFundamentoLegal: codigosFundamentosLegaisKey.split(','),
        });

        if (isMounted) {
          setListTratamentosAtributos(Array.isArray(response?.data) ? response.data : []);
        }
      } catch (error) {
        console.error('Erro ao buscar atributos dos tratamentos tributários opcionais.', error);
        if (isMounted) setListTratamentosAtributos([]);
      }
    };

    buscarAtributosTratamentos();

    return () => {
      isMounted = false;
    };
  }, [codigosFundamentosLegaisKey, isActive, mercadoriaIdsKey]);

  if (!isActive) return null;

  return (
    <>
      <QCXAuxiliarSelectFundamentosOpcionais
        name="ignorableFields.tratamentosTtce.metadados.opcionais"
        values={values}
        disabled={disabled}
        faturaId={faturaId}
        onMercadoriasPermitidasChange={onMercadoriasPermitidasChange}
      />

      <QCXAtributosTratamentoTributarioDuimpV3
        name="ignorableFields.tratamentosTtce.metadados.valores"
        tributos={listTratamentosAtributos}
        isConsult={disabled}
      />
    </>
  );
}
